import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MedioPagoSelect } from 'sharedComponents/select'

const MedioPagoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MEDIO PAGO' htmlFor='select-medioPago' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='medioPago'>
          {({ field }) => (
            <MedioPagoSelect
              {...field}
              id='select-medioPago'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MedioPagoFormGroup)
